import axios from 'axios';
// import { addToStorage } from '../utils/webStorage';
import {
  // APP_NAME_SPACE,
  // USER_EMAIL_RESOURCE_NAME,
  CAMPAIGNS_RESOURCE_NAME
} from '../config/constants';
import TEXTS from '../locale/texts.json';
import { downloadFile } from '../utils/downloadFile';
import { ApiError } from '../utils/errors';
import { message } from 'antd';
import CampaignApi from '../api/CampaignApi';
import ContactsApi from '../api/ContactsApi';
import ContactsGroupsApi from '../api/ContactsGroupsApi';
import CustomersApi from '../api/CustomersApi';

/**
 * GlobalStateContainer method for calling api
 * @param {string} resourceName - The name of the resource
 * @param {string} apiClassName - api class name that we call
 * @param {string} action - get|getOneOf|set|update|activate resource
 * @param {string} apiCallParams - arguments to api call
 * @param {boolean} showLoading - whether or not set show loading state
 * @param {Object} promiseCancelToken - axios cancel token
 * @param {Object} notification - notification { type, text }
 * @param {Function} onSuccess - onSuccess callback function
 * @param {Function} onError - onError callback function
 */

export const _callResource = async function({
  resourceName,
  apiClassName,
  action,
  apiCallParams,
  showLoading = true,
  promiseCancelToken,
  notification,
  onSuccess,
  onError
}) {
  console.group('_callResource GlobalStateContainer method');
  console.log('resourceName:', resourceName);
  console.log('apiClassName:', apiClassName);
  console.log('action:', action);
  !!apiCallParams && console.log('apiCallParams:', apiCallParams);
  console.groupEnd();

  let stateResourceName = resourceName[0].toLowerCase() + resourceName.slice(1);

  switch(action) {
    case 'get':
      stateResourceName = stateResourceName + 'Data';
      break;
    case 'getOneOf':
      stateResourceName = 'oneOf' + resourceName + 'Data';
      break;
    case 'getMsisdnsOf':
      stateResourceName = 'msisdnsOf' + resourceName + 'Data';
      break;
    case 'delete':
      stateResourceName = stateResourceName + 'Delete';
      break;
    case 'download':
      if (apiCallParams && apiCallParams.exportType === 'contacts') {
        stateResourceName = stateResourceName + 'ExportContacts';
      } else if (apiCallParams && apiCallParams.exportType === 'mobileOperatorsReport') {
        stateResourceName = stateResourceName + 'ExportOperators';
      } else if (apiCallParams && apiCallParams.exportType === 'exportMsisdns') {
        stateResourceName = stateResourceName + 'ExportOMsisdns';
      }

      stateResourceName = stateResourceName + 'Export';
      break;
    default:
      stateResourceName = action + resourceName;
  }

  if (showLoading) { this.setState({ [`${stateResourceName}IsLoading`]: true }); }

  this.setState({ activeItemId: apiCallParams && apiCallParams.id });

  this.setState({ [`${stateResourceName}Success`]: null });
  this.setState({ [`${stateResourceName}Error`]: null });

  const apiClass = ((_name) => {
    switch(_name) {
      case 'campaigns': return CampaignApi;
      case 'contacts': return ContactsApi;
      case 'contactsGroups': return ContactsGroupsApi;
      case 'senders': case 'details': return CustomersApi; // both method belong to customers api
      default: return null;
    }
  })(apiClassName);

  try {
    // make api call
    const res = await apiClass[`${action}${resourceName}`](apiCallParams, promiseCancelToken);
    if (action === 'download') {
      downloadFile(res.data, apiCallParams, apiClassName);
    } else {
      this.setState({ [`${stateResourceName}`]: res.data && res.data });
    }

    this.setState({
      [`${stateResourceName}IsLoading`]: false,
      activeItemId: null
    });

    // extra callbacks if success
    // such as redirects, notifications etc.
    if (onSuccess) {
      onSuccess(res);
    } else {
      if (notification) {
        if (notification.type === 'popup') {
          this.props.addNotification(notification.text);
        } else {
          message.success(notification.text, 3);
        }
      }
    }
  } catch(err) {
    console.log(`ERR resourceName: get${resourceName} error`, err);
    console.log(`ERR stateResourceName: ${stateResourceName}Error error`, err);

    if (axios.isCancel(err)) {
      // REQUEST IS CANCELLED
      console.log(`Request get${resourceName} is canceled`, err.message);
    } else {
      // REQUEST IS NOT OK
      if (onError) {
        onError(err);
      } else {
        if (action !== 'getOneOf' && action !== 'get') {
          message.error(`${TEXTS.cantDoRequest[this.props.lang]}: ${new ApiError(err).errorMessage}`, 7);
        }
      }

      // if (err.response && (err.response.status === 401 || err.response.status === 403)) {
      //   console.log(
      //     'inner logout'
      //   );
      //   // logout user
      //   this.props.logout();
      // }

      this.setState({
        [`${stateResourceName}IsLoading`]: false,
        activeItemId: null,
        [`${stateResourceName}Error`]: new ApiError(err, action === 'getOneOf' || action === 'get'),
        [`${stateResourceName}`]: null
      });
    }
  } finally {
    // remove finally state update
    // because of possible state updates
    // on unmounted components causing
    // browser memory leaks
    // this.setState({
    //   [`${stateResourceName}IsLoading`]: false,
    //   activeItemId: null
    // });
  }
};
